import { render, staticRenderFns } from "./shipmentRequestUpdate_bak.vue?vue&type=template&id=771b5924&scoped=true"
import script from "./shipmentRequestUpdate_bak.vue?vue&type=script&lang=js"
export * from "./shipmentRequestUpdate_bak.vue?vue&type=script&lang=js"
import style0 from "./shipmentRequestUpdate_bak.vue?vue&type=style&index=0&id=771b5924&prod&lang=scss"
import style1 from "./shipmentRequestUpdate_bak.vue?vue&type=style&index=1&id=771b5924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771b5924",
  null
  
)

export default component.exports